import api from '@/apis'

export const fetchList = params => api.get(`/mgroup`, { params })
export const setActiveState = (id, isActive) => api.delete(`/mgroup/${id}`, { isActive })
export const setExt = (id, data) => api.put(`/mgroups/${id}/set_ext`, data)
